export namespace ProductTranslations {
  export const common = {
    product: 'product',
    productExportConfiguration: 'productExportConfiguration',
  } as const;

  export const error = {
    productsUnableToLoadError: 'productsUnableToLoadError',
    productExportConfigurationsUnableToLoadError: 'productExportConfigurationsUnableToLoadError',
  } as const;

  export const exportConfigurations = {
    productExportConfigurationDeleteConfirmationText: 'productExportConfigurationDeleteConfirmationText',
    productExportConfigurationIncludeNoStockText: 'productExportConfigurationIncludeNoStockText',
  } as const;
}
